module.exports = __webpack_public_path__ + "assets/media/产品介绍视频.0b470bc1.mp4";